<template>
  <section>
    <v-dialog
      v-model="value"
      width="800"
    >
      <div class="dialog-container">
        <div class="dialog-header">
          <span>New Enquiry</span>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-body">
            <div class="form-item pd-b-30">
              <el-form-item
                ref="merchant_platform"
                :rules="rules.select"
                prop="merchant_platform">
                <select-quote-type v-model.number="formData.merchant_platform"></select-quote-type>
              </el-form-item>
            </div>
            <div class="form-item type-button pd-b-30">
              <span class="item-title">Name (Traditional Chinese)</span>
              <el-form-item
                ref="enquiry_type"
                :rules="rules.select"
                prop="enquiry_type">
                <v-radio-group
                  v-model="formData.enquiry_type"
                  :list="enquiry_type_list"/>
              </el-form-item>
            </div>
            <div class="flex-sb">
              <div class="form-half">
                <div class="form-item">
                  <span class="item-title"> Contact Person</span>
                  <el-form-item
                    ref="contact_type"
                    prop="contact_type">
                    <v-radio-group
                      v-model="formData.contact_type"
                      block
                      :list="enquiryContactPerson"/>
                  </el-form-item>
                </div>
                <div
                  v-if="formData.contact_type==2"
                  class="form-item">
                  <v-button
                    :icon="isFina?'user-tie':'user-circle'"
                    gray
                    @click="handlerSelectAccount">{{isFina?btn_refer_text:btn_text}}</v-button>
                </div>
                <template v-if="formData.contact_type==1">
                  <div class="form-item">
                    <span>Communication Preference</span>
                    <el-form-item
                      ref="language"
                      :rules="rules.select"
                      prop="language">
                      <v-radio-group
                        v-model="formData.language"
                        block
                        :list="langList"/>
                    </el-form-item>
                  </div>
                  <div
                    class="flex">
                    <div class="form-item width-80 mg-r-10">
                      <span class="item-title">Title</span>
                      <el-form-item
                        ref="title"
                        :rules="rules.select"
                        prop="title">
                        <v-select
                          v-model="formData.title"
                          :list="globalOptions.enquiry_title"/>
                      </el-form-item>
                    </div>
                    <div class="form-item flex-1">
                      <span class="item-title">Name</span>
                      <el-form-item
                        ref="name"
                        :rules="rules.input"
                        prop="name">
                        <v-input
                          v-model="formData.name"
                          uppercase />
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-item">
                    <span class="item-title">Mobile Number</span>
                    <el-form-item
                      ref="phone"
                      :rules="rules.mobile_no"
                      prop="phone">
                      <v-input
                        v-model="formData.phone"
                        maxlength="8"
                        :keyNumber="true"
                        uppercase></v-input>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span class="item-title">Email</span>
                    <el-form-item
                      ref="email"
                      :rules="rules.contact_email"
                      prop="email">
                      <v-input
                        v-model="formData.email"
                      ></v-input>
                    </el-form-item>
                  </div>
                </template>
              </div>
              <div class="form-half">
                <div
                  v-if="[10].includes(formData.enquiry_type)"
                  class="form-item">
                  <span class="item-title">Product Type</span>
                  <el-form-item
                    ref="product_type"
                    :rules="rules.select"
                    prop="product_type">
                    <v-select
                      v-model="formData.product_type"
                      :list="globalOptions.enquiry_product_type"/>
                  </el-form-item>
                  <el-form-item
                    v-if="[10,20].includes(formData.product_type)"
                    ref="product_type"
                    class="mg-t-10"
                    :rules="rules.select"
                    prop="product_type">
                    <v-select
                      v-model="formData.class_id"
                      :list="classList(formData.product_type)"/>
                  </el-form-item>
                </div>
                <!--                <div class="form-item width-fill">-->
                <!--                  <span class="item-title">Best Contact Time</span>-->
                <!--                  <el-form-item-->
                <!--                    ref="contact_dt"-->
                <!--                    :rules="rules.select"-->
                <!--                    prop="contact_dt">-->
                <!--                    <v-date-picker-->
                <!--                      v-model="formData.contact_dt"-->
                <!--                      :picker-options="pickerOptions"-->
                <!--                    />-->
                <!--                  </el-form-item>-->
                <!--                  <el-form-item-->
                <!--                    ref="contact_time_id"-->
                <!--                    :rules="rules.select"-->
                <!--                    prop="contact_time_id">-->
                <!--                    <v-select-->
                <!--                      v-model="formData.contact_time_id"-->
                <!--                      :list="globalOptions.enquiry_contact_time"-->
                <!--                      class="mg-t-15"/>-->
                <!--                  </el-form-item>-->
                <!--                </div>-->
                <div class="form-item">
                  <span class="item-title">Additional Message</span>
                  <el-form-item
                    ref="additional_msg"
                    :rules="rules.input"
                    prop="additional_msg">
                    <v-input
                      v-model="formData.additional_msg"
                      type="textarea"
                      :maxlength="1000"
                      :rows="4"
                    />
                  </el-form-item>
                </div>
                <div
                  class="form-item"
                >
                  <el-form-item
                    ref="is_policy_holder"
                    prop="is_policy_holder">
                    <v-checkbox
                      v-model="formData.is_policy_holder"
                      :isBoolean="false"
                    >
                      I am the policyholder
                    </v-checkbox>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <template>
          <div
            class="dialog-footer">
            <v-button
              gray
              @click="handleCancel">{{cancelText}}</v-button>
            <div>
              <v-button
                green
                @click="handleNext">
                {{btnText}}
              </v-button>
            </div>
          </div>
        </template>
      </div>
    </v-dialog>
    <attach-customer
      ref="attachCustomer"
      :customer-type="formData.merchant_platform"
      is-all-type></attach-customer>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import dayjs from 'dayjs'
import {saveEnquiry} from '@api/enquiry'
import {mapActions, mapState} from 'vuex'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import {createEnquiry} from '@/api/enquiry'
import SelectQuoteType from '@/views/components/select-quote-type'
export default {
  name: 'add-enquiry-form',
  components:{
    attachCustomer,
    SelectQuoteType
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:''
    },
    cancelText:{
      type:String,
      default:'Cancel'
    },
    btnText:{
      type:String,
      default:'Confirm'
    },
  },
  data(){
    return{
      isShow:false,
      formData:{
        mobile_no:'',
        is_policy_holder:0,
        email:'',
        rgtn_no:'',
        name: '',
        phone: '',
        additional_msg: '',
        contact_dt:'',
        pcy_no:'',
        contact_time_id:'',
        product_type:'',
        enquiry_type:10,
        class_id:11,
        company_id:'',
        title:'',
        contact_type:1,
        merchant_platform:1,
        language:'zh-HK'
      },
      pickerOptions: {
        disabledDate: (time) => {
          const day = time.getDay()
          const formattedDate = this.formatDate(time)
          const today = this.formatDate(new Date())
          const currentYear = dayjs().year()
          const year = dayjs(time).year()
          const nextYear = currentYear + 1
          return day === 0 || day === 6 || this.holidays.includes(formattedDate)||formattedDate<today||year > nextYear
        },
        shouldShowToday: true
      },
    }
  },
  computed: {
    ...mapState('account', ['customerId','selectCustomerData','referCustomerId','selectReferCustomerData']),
    isFina(){
      let {merchant_platform} = this.formData
      return Number(merchant_platform)==2
    },
    btn_text(){
      let text = ''
      if(this.customerId && this.selectCustomerData && this.selectCustomerData.isrd_nm){
        text = this.selectCustomerData.isrd_nm.trim() == ''? 'Unnamed Account' : this.selectCustomerData.isrd_nm
      }else{
        text = 'Select Customer'
      }
      if(text.length > 25){
        text = text.substr(0, 25) + '...'
      }
      return text
    },
    btn_refer_text(){
      let text = ''
      if(this.referCustomerId && this.selectReferCustomerData){
        text = this.selectReferCustomerData.isrd_nm.trim() == ''? 'Unnamed Account' : this.selectReferCustomerData.isrd_nm
      }else{
        text = 'Select Referrer'
      }
      if(text.length > 25){
        text = text.substr(0, 25) + '...'
      }
      return text
    },
    enquiry_type_list(){
      let {enquiry_type} = this.globalOptions||{}
      if(this.isFina){
        return enquiry_type.filter(item => [90].includes(item.id))
      }
      return enquiry_type.filter(item => [10,90].includes(item.id))
    },
    holidays() {
      let {holiday_data} = this.globalOptions || {}
      let holidays = holiday_data.map(holiday => holiday.date)
      return holidays
    },
    classList(product_type){
      return product_type =>{
        let arr =[]
        let {enquiry_cs_product_type} = this.globalOptions||{}
        enquiry_cs_product_type.some(item=>{
          let itemId = item.id.toString()
          const numberString = item.id.toString()
          const firstTwoDigits = numberString.slice(0, 2)
          const last = numberString.slice(2, 4)
          if(firstTwoDigits == product_type){
            let class_id = Number(last)
            let obj = {
              id:class_id,
              name:item.name
            }
            arr.push(obj)
          }
        })
        return arr
      }
    },
    enquiryContactPerson() {
      return [
        {
          id: 1,
          name: 'Guest'
        },
        {
          id: 2,
          name: 'HoldCover Account'
        },
      ]
    },
  },
  watch:{

  },
  destroyed() {
    this.clearData()
  },
  methods:{
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setSelectReferCustomerData','setReferCustomerId']),
    handlerSelectAccount(){
      this.$refs.attachCustomer.showAttachCustomer()
    },
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },
    handleCancel(){
      this.$refs['form'].resetFields()
      this.clearData()
      this.$emit('input',false)
    },
    handleNext(){
      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().createEnquiry()
        }

      })

    },
    clearData(){
      this.setCustomerId(null)
      this.setSelectCustomerData(null)
      this.setReferCustomerId(null)
      this.setSelectReferCustomerData(null)
    },
    network() {
      return {
        createEnquiry: async (params={}) => {
          let {contact_type} =this.formData
          if(contact_type==2){
            if(!this.isFina)
              params.customer_id = this.customerId
            else {
              params.referrer_id = this.referCustomerId
            }
          }
          const {data} = await createEnquiry({
            enquiry_id:this.enquiry_id,
            ...this.formData,
            ...params
          })
          this.$refs['form'].resetFields()
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.clearData()
          this.$emit('refresh')
          this.$emit('input',false)

        },
      }
    }
  },

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .width-80{
      width: 80px;
    }
    .type-button {
      // margin-right: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 20px;
      /deep/ .el-radio-group{
        display: flex;
      }
      ::v-deep .el-radio {
        //margin-right: 23px;
        margin-top: 8px;
        width: 50%;
        .el-radio__label {
          display: inline-block;

          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
          margin-right: 23px;
        }
      }
    }
    /deep/ .el-date-editor{
      width: 100% !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

  }
  .form-item{
    .select-type{
      display: flex;
      justify-content: space-between;
    /deep/.select-pay{
      margin-right: 30px;
      width: 50%;
    }
    }
  }
}
</style>
